import { render } from "./diandianrentou.vue?vue&type=template&id=7273b4b5&scoped=true"
import script from "./diandianrentou.vue?vue&type=script&lang=js"
export * from "./diandianrentou.vue?vue&type=script&lang=js"

import "./diandianrentou.vue?vue&type=style&index=0&id=7273b4b5&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7273b4b5"]])

export default __exports__